import React, { useState } from "react"

import dayjs from "dayjs"
import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import WithLoadingIndicator from "~tailwindui/Basics/WithLoadingIndicator"
import Table from "~tailwindui/Table/Table"

import DataDateRange from "components/OrganizationAdmin/components/DataDateRange"
import Header from "components/OrganizationAdmin/components/DisplayableFormikForm/Header"
import SubHeader from "components/OrganizationAdmin/components/DisplayableFormikForm/SubHeader"

const NoShowsPage = () => {
  const history = useHistory()
  const defaultStartDate = dayjs().startOf("year")
  const defaultEndDate = dayjs()
  const [startDate, setStartDate] = useState(defaultStartDate)
  const [endDate, setEndDate] = useState(defaultEndDate)

  const [studyGroupPage, setStudyGroupPage] = useState(1)
  const [studentPage, setStudentPage] = useState(1)

  const [studyGroupsResult] = useQuery({
    query: noShowStudyGroupsQuery,
    variables: { startDate, endDate, page: studyGroupPage },
  })
  const [studentsResult] = useQuery({
    query: noShowStudentsQuery,
    variables: { startDate, endDate, page: studentPage },
  })

  return (
    <>
      <Header title="No Shows"></Header>
      <DataDateRange
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />

      <SubHeader title="Study Groups" />
      <WithLoadingIndicator result={studyGroupsResult}>
        {({ data }) => (
          <>
            {data.viewer.organization.noShowStudyGroups.data.length > 0 ? (
              <Table
                changePage={setStudyGroupPage}
                data={data.viewer.organization.noShowStudyGroups}
                rowCallback={({ studyGroup }) =>
                  history.push(`/study_groups/${studyGroup.id}`)
                }
                cols={[
                  {
                    header: "Name",
                    value: record => record.studyGroup.name,
                  },
                  {
                    header: "Students",
                    value: record => (
                      <ul key="studentsList" className="list-none">
                        {record.studyGroup.students.map(student => (
                          <li key={student.id}>{student?.fullName}</li>
                        ))}
                      </ul>
                    ),
                  },
                  {
                    header: "No Show Sessions",
                    value: record => record.noShows,
                  },
                  {
                    header: "Teacher",
                    value: record =>
                      record.studyGroup.teachers.length > 0 ? (
                        <ul className="list-none">
                          {record.studyGroup.teachers.map(teacher => (
                            <li key={teacher.id}>{teacher?.fullName}</li>
                          ))}
                        </ul>
                      ) : (
                        "N/A"
                      ),
                  },
                ]}
              />
            ) : (
              <span>
                Great! There are no study groups with multiple no shows in the
                given date range.
              </span>
            )}
          </>
        )}
      </WithLoadingIndicator>

      <SubHeader title="Students" />
      <WithLoadingIndicator result={studentsResult}>
        {({ data }) => (
          <>
            {data.viewer.organization.noShowStudents.data.length > 0 ? (
              <Table
                changePage={setStudentPage}
                data={data.viewer.organization.noShowStudents}
                rowCallback={({ student }) =>
                  history.push(`/students/${student.id}`)
                }
                cols={[
                  { header: "Name", value: ({ student }) => student.fullName },
                  {
                    header: "School",
                    value: ({ student }) => student.school?.name,
                  },
                  {
                    header: "No Show Sessions",
                    value: record => record.noShows,
                  },
                ]}
              />
            ) : (
              <span>
                Great! There are no students with multiple no shows in the given
                date range.
              </span>
            )}
          </>
        )}
      </WithLoadingIndicator>
    </>
  )
}

const noShowStudyGroupsQuery = gql`
  query noShowStudyGroupsQuery(
    $startDate: DateTime!
    $endDate: DateTime!
    $page: Int!
  ) {
    viewer {
      organization {
        noShowStudyGroups(
          startDate: $startDate
          endDate: $endDate
          page: $page
        ) {
          currentPage
          totalPages
          data {
            studyGroup {
              id
              name
              students {
                id
                fullName
              }
              teachers {
                id
                fullName
              }
            }
            noShows
          }
        }
      }
    }
  }
`
const noShowStudentsQuery = gql`
  query noShowStudentsQuery(
    $startDate: DateTime!
    $endDate: DateTime!
    $page: Int!
  ) {
    viewer {
      organization {
        noShowStudents(startDate: $startDate, endDate: $endDate, page: $page) {
          currentPage
          totalPages
          data {
            student {
              id
              fullName
              school {
                id
                name
              }
            }
            noShows
          }
        }
      }
    }
  }
`

export default NoShowsPage
